import {
  createStyles,
  withStyles,
  Theme,
  darken,
  useTheme,
} from '@material-ui/core';
import React from 'react';
import { Alert, AlertProps } from '@material-ui/lab';
import FsAlertIcon from 'ui-elements/icons/FsAlert';
import { alert } from 'globals/colors';

const FsAlert = withStyles(({ spacing, palette }: Theme) =>
  createStyles({
    root: {
      borderRadius: spacing(1),
      borderColor: alert.ERROR,
      background: palette.error.light,
      fontSize: 16,
      color: alert.ERROR,
      display: 'flex',
      alignItems: 'center',
    },
    outlinedSuccess: {
      borderColor: alert.SUCCESS,
      background: palette.success.light,
      color: alert.SUCCESS,
    },
    outlinedWarning: {
      borderColor: palette.warning.main,
      background: palette.warning.light,
      color: darken(palette.warning.dark, 0.1),
    },
    outlinedInfo: {
      borderColor: palette.info.main,
      background: palette.info.light,
      color: darken(palette.info.dark, 0.1),
    },
  })
)(({ severity, ...otherProps }: AlertProps) => {
  const { palette } = useTheme();

  const iconColors = {
    success: alert.SUCCESS,
    info: palette.info.dark,
    warning: palette.warning.dark,
    error: alert.ERROR,
  };

  return (
    <Alert
      {...otherProps}
      severity={severity}
      variant="outlined"
      icon={<FsAlertIcon color={severity ? iconColors[severity] : undefined} />}
    />
  );
});

export default FsAlert;
